
import React, { useEffect, useState } from 'react';
import {IProps, IEditNoteType, ILinkTextAreaReactProps, IHandlers} from './types';
import {Button, Dialog, LinearProgress, Paper, PaperProps, TextField} from '@material-ui/core';
import Draggable from 'react-draggable';
import { useStyles } from './style';
import UtilsService from "app/services/utils/utils.service";


import SimpleDialog from "app/common/SimpleDialog";
import {EventNoteSharp as EventNoteSharpIcon} from '@material-ui/icons';

import { Alert } from '@material-ui/lab';

const NS = 'EditBookingNotes';
const draggableEditBookingTitleId = "draggable-edit-booking-notes-title";

export default function EditBookingNotes(props: IProps & IHandlers) {

  const classes = useStyles();
  const {
    showDialog,
    saving,
    saveError,
    errorMsg,
    loadCustomerError,
    customerErrorMsg,

    booking,
    customer,

    staffEditEnabled,

    isManager,
    staffError,
    handleSave,
    handleClose,
  } = props;

  const [editBookingNotes, setEditBookingNotes] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const [editCustomerNotes, setEditCustomerNotes] = useState<string>("");
  const [editManagerNotes, setEditManagerNotes] = useState<string>("");
  const [staffName, setStaffName] = useState<string>("");

  const [disabledSave, setDisabledSave] = useState<boolean>(true);

  const [showCancelConfirm, setShowCancelConfirm] = useState<boolean>(false);

  useEffect(() => {
    (showDialog !== open) && setOpen(showDialog);
  }, [showDialog]);

  useEffect(() => {
    !open && setDefault();
  }, [open]);

  const setDefault = () => {
    setDisabledSave(true);
    setShowCancelConfirm(false);
    setStaffName("");
    setEditBookingNotes("");
    setEditCustomerNotes("");
    setEditManagerNotes("");
  }

  useEffect(() => {
    booking && setEditBookingNotes(booking.notes);
  }, [booking]);

  useEffect(() => {
    customer && setEditCustomerNotes(customer.notes ? customer.notes.toString() : '');
    customer && isManager && setEditManagerNotes(customer.managerNotes ? customer.managerNotes.toString() : '');
  }, [customer]);

  const strUtil = (str: string) => {
    if(!str) return "";
    else return str;
  }

  useEffect(() => {

    if(booking) {
      let flag: boolean = false;
      if(strUtil(editBookingNotes) !== strUtil(booking.notes)) flag = true;
      if(customer && strUtil(editCustomerNotes) !== strUtil(customer.notes)) flag = true;
      if(customer && strUtil(editManagerNotes) !== strUtil(customer.managerNotes)) flag = true;
      setDisabledSave(!flag);
    }
  }, [editBookingNotes, editCustomerNotes, editManagerNotes]);

  const handleClosePressed = () => {
    disabledSave && setOpen(false);
    if(disabledSave === false) {
      setShowCancelConfirm(true);
    } else handleClose();
  }

  const _handleClose = () => {
    setOpen(false);
    handleClose();
  }

  const handleChange = (str: string, noteType: IEditNoteType) => {

    switch (noteType) {
      case IEditNoteType.Booking:
        setEditBookingNotes(str);
        break;
      case IEditNoteType.Customer:
        setEditCustomerNotes(str);
          break;
      case IEditNoteType.Manager:
        setEditManagerNotes(str);
        break;
      default:
        setStaffName(str);
    }
  }

  return (
    <Dialog
      data-testid="edit-note-dialog-test-id"
      open={open}
      scroll="paper"
      // fullWidth={true}
      className={classes.root}
      onClose={() => {
        saving ? () => {} : handleClosePressed()
      }}
      PaperComponent={DraggableComponent}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <div className={classes.titleContainer} id={draggableEditBookingTitleId}>
        <EventNoteSharpIcon className={classes.noteIcon} />
        <span className={classes.titleText}>
          EDIT BOOKING NOTES
        </span>
        <div style={{flex: 1}}></div>
      </div>
      {
        saving &&
        <LinearProgress color="primary" />
      }
      <div className={classes.noteContainer} >
        <LinkTextAreaReact dataTestId="edit-note-booking-note-test-id" labelText={"Booking Notes"} value={editBookingNotes} handleChange={(str: string) => handleChange(str, IEditNoteType.Booking)} />
        {
          !loadCustomerError && customer &&
          <LinkTextAreaReact dataTestId="edit-note-customer-note-test-id" labelText={"Customer Notes"} style={{marginTop: 18}} value={editCustomerNotes} handleChange={(str: string) => handleChange(str, IEditNoteType.Customer)} />
        }
        {
          isManager && !loadCustomerError && customer &&
          <LinkTextAreaReact dataTestId="edit-note-manager-note-test-id" labelText={"Manager Notes"} style={{marginTop: 18}} value={editManagerNotes} handleChange={(str: string) => handleChange(str, IEditNoteType.Manager)} />
        }
        {
          staffEditEnabled &&
          <LinkTextAreaReact
            dataTestId="edit-note-staff-test-id"
            labelText={"Staff (*)"} style={{marginTop: 18}}
            value={staffName} handleChange={(str: string) => handleChange(str, IEditNoteType.Staff)}
            validation={staffEditEnabled}
            error={staffError}
            errorMsg={'This field is required'}
          />
        }
      </div>
      {
        loadCustomerError &&
        <div style={{padding: 15}} data-testid="edit-note-load-customer-error-test-id">
          <Alert severity="warning">{customerErrorMsg}</Alert>
        </div>
      }
      {
        saveError &&
        <div style={{padding: 15}} data-testid="edit-note-save-error-test-id">
          <Alert severity="error">{errorMsg}</Alert>
        </div>
      }
      <div className={classes.btnContainer}>
        <Button data-testid="edit-note-cancel-btn-test-id" disabled={saving} onClick={() => handleClosePressed()} color="primary" autoFocus>CANCEL</Button>
        <div style={{flex: 1}}></div>
        <Button
          data-testid="edit-note-save-btn-test-id"
          disabled={disabledSave || saving}
          variant="contained" color="primary" className={classes.btnSave}
          onClick={() => handleSave(editBookingNotes, editCustomerNotes, editManagerNotes, staffName)}
        >
          SAVE
        </Button>
      </div>
      <SimpleDialog
        dataTestId="edit-note-confirm-modal-test-id"
        isOpen={showCancelConfirm}
        title="Are you sure?"
        description="Your changes will not be saved"
        confirmText="Confirm"
        rejectText="No"
        handleConfirm={() => {
          _handleClose();
        }}
        handleReject={() => {
          setShowCancelConfirm(false);
        }}
      />

    </Dialog>
  );
}

/** This component uses react-draggable which lets us specify the draggable item by passing the selector item we want to make draggable to the handle prop. */
function DraggableComponent(props: JSX.IntrinsicAttributes & PaperProps) {
  return (
    <Draggable handle={`#${draggableEditBookingTitleId}`} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const LinkTextAreaReact = (props: ILinkTextAreaReactProps) => {

  const {style, labelText, value, enableTextLink = true, error, validation, errorMsg, dataTestId, handleChange} = props;
  const classes = useStyles();

  const onchange = (str: string) => {
    const temp = enableTextLink ? UtilsService.addLinksToText(str) : str;
    handleChange(temp);
  }

  return (
    <div className={classes.textArea} style={style}>
      <TextField
        data-testid={dataTestId}
        multiline={true}
        fullWidth={true}
        value={value}
        label={labelText}
        onChange={(e: any) => {
          onchange(e.target.value);
        }}
        error={error && validation}
        helperText={errorMsg}
      />
    </div>
  );
}
